// extracted by mini-css-extract-plugin
module.exports = {"privacyPageWrapper":"privacypolicy_privacyPageWrapper__2sXF6","header":"privacypolicy_header__WbMlS","content":"privacypolicy_content__3eTEn"};